import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { FREE_ANALYSES_PER_DAY, PRO_PLAN } from "../model/PLANS";

const PERIOD = msg({
  id: "billing.pro.period",
  message: "{days, plural, one {# day} other {# days}}",
});
const FREE_LIMIT = msg({
  id: "billing.free.limit",
  message: "{count} a day",
});

// Цена и срок Pro и дневной лимит бесплатной версии в языке интерфейса: «299 ₽», «30 дней»,
// «5 в сутки».
export const useProPlanLabels = () => {
  const { i18n, _ } = useLingui();
  const price = new Intl.NumberFormat(i18n.locale, {
    style: "currency",
    currency: "RUB",
    currencyDisplay: "narrowSymbol",
    maximumFractionDigits: 0,
  }).format(PRO_PLAN.priceRub);
  return {
    price,
    period: _({ ...PERIOD, values: { days: PRO_PLAN.periodDays } }),
    freeLimit: _({ ...FREE_LIMIT, values: { count: FREE_ANALYSES_PER_DAY } }),
  };
};
